module.exports = __webpack_public_path__ + "img/13.c4651a35.jpg";